<template>
  <div class="mapView">
    <article v-if="point.location.error" class="message is-danger">
      <div class="message-header">
        <p>Error</p>
      </div>
      <div class="message-body">
        <p>The server responded with an error: {{point.location.message}}</p>
      </div>
    </article>
    <GmapMap
      v-else
      class="google-map"
      :center="{lat:point.location.lat, lng:point.location.long}"
      :zoom="goodZoomLevel"
      map-type-id="satellite"
    >
      <GmapMarker
        :position="{lat:point.location.lat, lng:point.location.long}"
      />
      <GmapCircle
        :center="{lat:point.location.lat, lng:point.location.long}"
        :radius="point.location.accuracy / 2"
        :visible="true"
      />
    </GmapMap>
  </div>
</template>

<script>
export default {
  name: 'mapView',
  props: {
    point: [Object]
  },
  computed: {
    goodZoomLevel () {
      if (this.point.location.error) return 0
      else if (typeof this.point.location.accuracy !== 'number') return 12
      else if (this.point.location.accuracy > 1500) return 14
      else if (this.point.location.accuracy > 1000) return 15
      else if (this.point.location.accuracy > 500) return 16
      else if (this.point.location.accuracy > 200) return 19
      else return 21
    }
  }
}
</script>

<style scoped>
.mapView {
  height: 100%;
}
.google-map {
  width: 100%;
  height: 100%;
  min-height: 300px;
}
</style>
